<template>
  <div>
    <depts-mobile/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import DeptsMobile from "./DeptsMobile";
import DeptsDesktop from "./DeptsDesktop";

export default {
  name: "Depts",
  components: {DeptsDesktop, DeptsMobile},
  computed: {
    ...mapGetters([
      'isMobile'
    ])
  }
}
</script>


<style scoped>

</style>
